import { Component, ViewChild, Inject, inject, DestroyRef } from '@angular/core';
import { ServicesService } from 'src/services/services.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { finalize } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute, Router } from '@angular/router';

export interface galleryData {
  gallery_id: number;
  image_name: number;
  title: any;
}

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss']
})
export class GalleryComponent {

  displayedColumns: string[] = [
    'gallery_id',
    'image_name',
    'title',
    'action'
  ]
  private destoryRef = inject(DestroyRef);
  @ViewChild(MatPaginator)
  paginator!: MatPaginator;

  @ViewChild(MatSort)
  sort!: MatSort;

  ELEMENT_DATA: galleryData[] = [];
  dataSource!: MatTableDataSource<galleryData>;
  result: any;
  main: any;
  event_id: any;
  gallery_id: any;

  constructor(
    private service: ServicesService,
    private dialog: MatDialog,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private route: ActivatedRoute,
  ) { }

  openDialog() {
    const dialogRef = this.dialog.open(addgallery, {
      data: {
        gallery_id: this.gallery_id,
        event_id: this.event_id,
      },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getGallery();
    });
  }

  openEditDialog(gallery_id: number) {
    this.router.navigate([`/AppEditGallery/${this.event_id}`, { 'gallery_id': gallery_id }]);
  }

  ngOnInit() {
    console.log(this.route.snapshot.params['event_id']);
    this.event_id = this.route.snapshot.params['event_id'] || sessionStorage.getItem('Event_ID');
    console.log(this.event_id);


    this.getGallery();
  }


  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  getGallery() {
    this.ELEMENT_DATA = [];
    this.spinner.show();
    this.service.getGallery(this.event_id).pipe(takeUntilDestroyed(this.destoryRef), finalize(() => this.spinner.hide())).subscribe(
      data => {
        this.result = data;
        this.main = this.result.data;
        for (const item of this.main) {
          this.ELEMENT_DATA.push({
            gallery_id: item.gallery_id,
            image_name: item.image_name,
            title: item.title
          });
        }
        this.dataSource = new MatTableDataSource<galleryData>(this.ELEMENT_DATA);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    );
  }

  deleteGallery(gallery_id: any) {
    const buttonClicked = window.confirm('Are You Sure To Delete This Gallery?');
    if (buttonClicked === true) {
      this.service.deleteGallery(gallery_id).pipe(takeUntilDestroyed(this.destoryRef)).subscribe(
        data => {
          this.toastr.warning('Gallery deleted successfully');
          this.ELEMENT_DATA = this.ELEMENT_DATA.filter(item => item.gallery_id !== gallery_id);
          this.dataSource.data = this.ELEMENT_DATA;
        }
      );
    }
  }
}


@Component({
  selector: 'addgallery.html',
  templateUrl: 'addgallery.html',
})
export class addgallery {
  addgalleryform: FormGroup;
  imagePath: any;
  title: any;
  description: any;
  message!: string;
  imagefileURL!: any | ArrayBuffer;
  event_id: any;


  constructor(
    private gallery: FormBuilder,
    private galleryservice: ServicesService,
    private toastr: ToastrService,
    private dialogRef: MatDialogRef<addgallery>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // Receive event_id from dialog data
    this.event_id = data.event_id;

    this.addgalleryform = this.gallery.group({
      image_name: this.imagePath,
      title: '',
      description: ''
    });
  }

  previewpimage(files: any) {
    console.log(this.event_id);

    if (files.length === 0) {
      return;
    }
    var mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = 'Only images are supported.';
      return;
    }
    var reader = new FileReader();
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.imagefileURL = reader.result;
      this.galleryservice.uploadimage(this.imagefileURL, this.event_id + "/gallery").subscribe((data: any) => {
        this.imagePath = data['image_name'];
        console.log("imgpath" + this.imagePath);
        console.log("imagefileURL" + this.imagefileURL);
      });
    };
  }

  onFormSubmit() {
    this.addgalleryform.patchValue({
      image_name: this.imagePath
    })
    const formData = this.addgalleryform.value;

    const hasNonEmptyField = Object.values(formData).some(value => value !== null && value !== '');
    if (this.addgalleryform.valid && hasNonEmptyField) {
      this.galleryservice.addGallery(this.addgalleryform.value).subscribe({
        next: (val: any) => {
          this.toastr.success(' Gallery added successfully ');
          this.dialogRef.close(true);
        },
        error: (err: any) => {
          console.error(err);
        },
      });
    } else {
      this.toastr.error("Please fill the form")
    }
  }
}
